/* Where each tick of the reader's rail sits, in px from the rail's top.

   At rest the ticks are evenly spaced. Under the cursor they spread apart, the
   way the macOS Dock magnifies, so one book can be picked out of a dense run.
   The rail's height never changes: the extra room given to the gaps near the
   cursor is taken back from the gaps far from it, separately above and below
   the pointed-at tick, so that tick stays where it was and does not slide out
   from under the pointer. */

/* How wide the magnified region is, in px of rail. */
const SPREAD = 26;
/* The gap the cursor should open up between two ticks, in px. The gain is
   derived from it, so a sparse rail (already that wide) barely moves and a
   dense one opens up the most. */
const TARGET_GAP = 16;

export function restPositions(count, pitch) {
  return Array.from({ length: count }, (_, i) => i * pitch);
}

export function magnifiedPositions(count, pitch, cursor) {
  if (count < 2 || cursor == null) return restPositions(count, pitch);
  const gain = Math.max(0, TARGET_GAP / pitch - 1);
  const gaps = [];
  for (let i = 0; i < count - 1; i++) {
    const mid = (i + 0.5) * pitch;
    gaps.push(pitch * (1 + gain * Math.exp(-((mid - cursor) ** 2) / (2 * SPREAD * SPREAD))));
  }
  const at = Math.max(0, Math.min(count - 1, Math.round(cursor / pitch)));
  const above = gaps.slice(0, at).reduce((sum, gap) => sum + gap, 0);
  const below = gaps.slice(at).reduce((sum, gap) => sum + gap, 0);
  const scaleAbove = above ? (at * pitch) / above : 1;
  const scaleBelow = below ? ((count - 1 - at) * pitch) / below : 1;
  const positions = [0];
  for (let i = 0; i < count - 1; i++) {
    positions.push(positions[i] + gaps[i] * (i < at ? scaleAbove : scaleBelow));
  }
  return positions;
}

/* The tick nearest a point on the rail. */
export function nearestTick(positions, y) {
  let best = 0;
  for (let i = 1; i < positions.length; i++) {
    if (Math.abs(positions[i] - y) < Math.abs(positions[best] - y)) best = i;
  }
  return best;
}
